export default __webpack_public_path__ + "static/media/ConRodImg.8af3bd80.png";